/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { CircleCheckIcon, CircleExclamationIcon, CircleIcon, CircleInfoIcon, EllipsisHIcon, TriangleExclamationIcon } from "../../../../../Basis/FontAwesome";
import Symbol, { Symbole } from "../../../Queries/Symbol";
import AppNotificationIconProps from "./AppNotificationIconProps";
import "./AppNotificationIcon.scss";

function ermittleIconZuSymbol(symbol: Symbol) {
    switch (symbol) {
        case Symbole.info:
            return <CircleInfoIcon className="lan-appnotifications__icon lan-appnotifications__icon--info" />
        case Symbole.warnung:
            return <TriangleExclamationIcon className="lan-appnotifications__icon lan-appnotifications__icon--warning" />
        case Symbole.fehler:
            return <CircleExclamationIcon className="lan-appnotifications__icon lan-appnotifications__icon--error" />
        case Symbole.laufend:
            return <EllipsisHIcon className="lan-appnotifications__icon lan-appnotifications__icon--running fa-pulse2" />;
        case Symbole.erfolg:
            return <CircleCheckIcon className="lan-appnotifications__icon lan-appnotifications__icon--success" />;
        default:
            return <CircleIcon className="lan-appnotifications__icon lan-appnotifications__icon--default" />;
    }
}

export default function AppNotificationIcon(props: AppNotificationIconProps) {
    return ermittleIconZuSymbol(props.symbol);
}